import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h2>
          This domain is Parked
        </h2>
      </header>
    </div>
  );
}

export default App;
